import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextInput from '../../components/TextInput';
import CheckboxInput from '../../components/CheckboxInput';
import Button from '../../components/Button';
import SkeletonLoader from '../../components/SkeletonLoader';
import leadStatusApi from '../../api/leadStatusApi';
import { useToast } from '../../contexts/ToastContext';
import { ROUTES } from '../../constants';

const AddStatus = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    is_default: 0,
    color: '#000000',
    is_active: 1,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    });
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setValidationErrors({});

    try {
      await leadStatusApi.createLeadStatus(formData);
      addToast('Lead status created successfully!', 'success');
      navigate(ROUTES.LEAD_STATUS);
    } catch (err) {
      console.error('Failed to add lead status:', err);
      if (err.response && err.response.status === 422) {
        setValidationErrors(err.response.data.errors || {});
        addToast(err.response.data.message || 'Validation failed. Please check your input.', 'error');
      } else {
        addToast(err.response?.data?.message || 'Failed to add lead status. Please try again.', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-800 rounded-lg shadow-md text-text-white">
      <h1 className="text-3xl font-bold mb-6">Add New Status</h1>
      {loading ? (
        <SkeletonLoader type="form" />
      ) : (
        <form onSubmit={handleSubmit}>
          <TextInput
            label="Name"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
            required={true}
            placeholder="Name"
            error={validationErrors?.name?.[0]}
          />
          <TextInput
            label="Color"
            name="color"
            id="color"
            type="color"
            value={formData.color}
            onChange={handleChange}
            required={true}
            className="h-10"
            placeholder="Color"
            error={validationErrors?.color?.[0]}
          />
          <CheckboxInput
            label="Is Default"
            name="is_default"
            id="is_default"
            checked={formData.is_default}
            onChange={handleChange}
          />
          <div className="flex items-center justify-between mt-6">
            <Button
              type="submit"
              className="bg-accent-red hover:bg-red-700 text-white"
              loading={loading}
            >
              Add Status
            </Button>
            <Button
              type="button"
              onClick={() => navigate(ROUTES.LEAD_STATUS)}
              className="bg-gray-500 hover:bg-gray-600 text-white"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddStatus;